import { DefaultTheme } from "styled-components";

const defaultTheme: DefaultTheme = {
  backgroundColors: {
    primary: "#FFF9F4",
    secondary: "#000",
    tertiary: "#f9f9f9",
  },
  colors: {
    primary: "#224C5D",
    secondary: "#2F5A50",
    tertiary: "#A78F67",
    quaternary: "#424242",
    quinary: "#603634",
  },
  textColors: {
    primary: "#424242",
    secondary: "#f9f9f9",
    tertiary: "#a78f67",
  },
  factColors: {
    primary: "#FAF7CB",
    secondary: "#F7E2D3",
    tertiary: "#E7DBCB",
  },
  breakpoints: {
    xs: "(max-width: 480px)",
    sm: "(max-width: 680px)",
    md: "(max-width: 992px)",
    lg: "(max-width: 1500px)",
    xl: "(max-width: 1650px)",
    xxl: "(max-width: 2000px)",
    hover: "(min-width: 821px)",
  },
  margins: {
    bottom: "70px",
    bottomMobile: "48px",
    inner: "0 100px",
  },
  filter: {
    gold: "invert(59%) sepia(49%) saturate(265%) hue-rotate(359deg) brightness(89%) contrast(89%)",
  },
  shadow: {
    primary: "0px 5px 20px rgba(0, 0, 0, 0.1)",
  },
};

export default defaultTheme;
